import { render, staticRenderFns } from "./TransferModule.vue?vue&type=template&id=ba3969b0&"
import script from "./TransferModule.vue?vue&type=script&lang=js&"
export * from "./TransferModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports